module.exports = __webpack_public_path__ + "33dbac6a42ecd959ccb09033fb481bbf.svg";